<app-landing-header></app-landing-header>
<app-dynamic-content blocktitle="Marketing - Landing Page - Anonymous"></app-dynamic-content>
<app-course-carousel selector="newcourses"></app-course-carousel>
<app-course-carousel selector="trendingcourses"></app-course-carousel>
<app-landing-ce-socials></app-landing-ce-socials>
<app-course-carousel selector="newethics"></app-course-carousel>

<app-sales-box></app-sales-box>
